import React, { PureComponent } from 'react';
import {
  Modal, ModalBody,
} from 'reactstrap';
import PropTypes from 'prop-types';
import AssetModalContent from './AssetModalContent';

class AssetModal extends PureComponent {
  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    isModalAsset: PropTypes.bool.isRequired,
    toggleAsset: PropTypes.func.isRequired,
    userInfo: PropTypes.shape({}).isRequired,
    contacts: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    setDocument: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
    };
  }

  render() {
    const {
      toggleAsset, isModalAsset, data, userInfo, contacts, setDocument,
    } = this.props;
    const { accesses } = userInfo;
    return (
      <Modal
        isOpen={isModalAsset}
        toggle={toggleAsset}
        modalClassName="ltr-support"
        className="modal-dialog--lightOfficial modal-dialog--header theme-light modal-bigger"
      >
        <ModalBody className="p-0">
          <AssetModalContent setDocument={setDocument} accesses={accesses} isViewOnly contacts={contacts} toggleAsset={toggleAsset} data={data} />
        </ModalBody>
      </Modal>
    );
  }
}

export default AssetModal;
